// import Vue from "vue/types/vue";
import Vue from "vue";
import VueRouter from 'vue-router'

import index from './index/index'
import shop from './shop/index'
import application_purchase from './purchase/application'
import purchase from './purchase/index'
import details from './details/index'
import application_payment from './payment/application'
import payment from './payment/index'
import service_payment from './payment/service_index'
import search from './search/index'
import WeChat from './payment/WeChat'
import balance from './payment/balance'
import balance_application from "./payment/balance_application";
import balance_service from "./payment/balance_service";
import WeChat_application from './payment/WeChat_application'
import WeChat_service from "@/components/home/payment/WeChat_service";
import chenganli from './case/index'
import chenganli_xiangqing from './case/details'
import lighting from './lighting/index'
import lighting_xiangqing from './lighting/details'
import college from './college/index'
import category from './college/category'
import article from "./college/article";
import novice from "./college/novice";
import shops from "./shops/index"
import commodity from './shops/commodity'
import anli from './shops/case'
import yicaixiu from './shops/video'
import fangan from './shops/programme'
import diandeng from './shops/light'
import biaozhun from './shops/standard'
import gongsiziliao from './shops/companyData'
import fuwu from './shops/service'
import service_index from './service/index'
import service_search from './service/search'
import service_details from './service/details'
import ershousp from './second_goods/index'
import service_purchase from "@/components/home/purchase/service_purchase";
import general from "./general/index"
import testing from "./testing/index"
import detailsservice from "./case/detailsservice";
import detailsfuwu from "./lighting/detailsfuwu";
import dianpu_index from "./details/dianpu_index";
import dianpu_details from "./service/dianpu_details";
import dianpu_casedetails from "./case/dianpu_casedetails";
import dianpu_ligs from "./lighting/dianpu_ligs";
import dianpu_fuwucase from "./case/dianpu_fuwucase";
import leaflet from "./signup/leaflet";
import  application from  './signup/application';
// import showproduct from "./shops/showproduct";
import pinpaizhanshi from "./shops/pinpaizhanshi";
import chat_room from "./details/chat_room";
import chat_list from "./details/chat_list";
import chat_new from "./details/chat_new";
import dianpu_new from "./details/dianpu_new";
import chanpinku_info from "./details/chanpinku_info"
import tu from "./tu/index";
import test from "./test";
import index_new from "./purchase/index_new";
import video_details from "./shops/video_details";
import program_details from "./shops/program_details";
import standard_details from "./shops/standard_details";

import wiki from "./wiki/index";
import wiki_search from "./wiki/search";
import wiki_detail from "./wiki/detail";

import bidding from "./bidding/index";
import bidding_single from "./bidding/single";
import shop_bidding from "./shops/bidding";

import self_goods from "./self_goods/index";
import self_goods_detail from "./self_goods/detail";

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            name: 'home',
            path: '/',
            component: index
        },
        {
            name: 'tu',
            path: '/tu/:id',
            component: tu
        },
        // {
        //     path:'/showproduct',
        //     component:showproduct
        // },
        {
            name: 'juyishangcheng',
            path: '/shop',
            component: shop
        },{
        path:'/pinpaizhanshi',
            component:pinpaizhanshi
        },

        // {
        //     path: '/purchase',
        //     component: purchase
        // },

        {
            path: '/purchase/:id',
            component: purchase
        },
        {
            path: '/purchase/application/:id',
            component: application_purchase
        },
        {
            path: '/details',
            component: details
        },
        {
            name: 'goods_detail',
            path: '/details/:id',
            component: details
        },
        {
            path: '/dianpu_index/:id',
            component: dianpu_index
        },
        {
            path: '/dianpu_details/:id',
            component: dianpu_details
        }
        ,
        {
            path: '/dianpu_casedetails/:id',
            component: dianpu_casedetails
        },
        {
            path: '/dianpu_fuwucase/:id',
            component: dianpu_fuwucase
        },
        {
            path: '/payment/:id',
            component: payment
        },
        {
            path: '/service_payment/:id',
            component: service_payment
        },
        {
            path: '/payment/application/:order_id',
            component: application_payment
        },
        {
            name: 'goods_search',
            path: '/search',
            component: search
        },

        {
            path: '/WeChat/:id',
            component: WeChat
        },
        {
            path: '/balance/:id',
            component: balance
        },
        {
            path: '/balance_application/:id',
            component: balance_application
        },
        {
            path: '/balance_service/:id',
            component: balance_service
        },
        {
            path: '/WeChat_service/:id',
            component: WeChat_service
        },
        {
            path: '/wechat/pay/application/:order_id',
            component: WeChat_application
        },
        {
            path: '/case',//主页成功案例
            component: chenganli
        },
        {
            path: '/detailsservice/:id',
            component: detailsservice
        },
        {
            path: '/detailsfuwu/:id',
            component: detailsfuwu
        },
        {
            path: '/case_details/:id',//案例详情
            component: chenganli_xiangqing
        },

        {
            path: '/lighting',//主页点灯
            component: lighting
        },
        {
            path: '/lighting_details/:id',//点灯详情
            component: lighting_xiangqing
        },
        {
            path: '/dianpu_ligs/:id',
            component: dianpu_ligs
        },

        {
            path: '/college',
            component: college
        },
        // {
        //     path: '/college/:id',
        //     component: college
        // },.
        {
            path: '/trans/purchase',
            component: article
        },
        {
            path: '/college/category',//全部
            component: category
        },
        // {
        //     path: '/college/category/:id',//全部
        //     component: category
        // },
        {
            path: '/college/category/:id',//全部详情
            component: article
        },
        {
            path: '/college/novice',//新手
            component: category
        },
        {
            path: '/college/novice:id',//新手
            component: category
        },
        {
            path: '/college/novice/:id',//新手
            component: novice
        },
        {
            path: '/college/promote',//专项提升
            component: category
        },
        {
            path: '/college/promote:id',//专项提升
            component: category
        },
        {
            path: '/college/programme',//方案
            component: category
        },
        {
            path: '/college/programme:id',//方案
            component: category
        },
        {
            path: '/college/programme/:id',//方案详情
            component: article
        },
        {
            path: '/college/video',//仪才秀
            component: category
        },
        {
            path: '/college/video:id',//仪才秀
            component: category
        },
        {
            path: '/college/video/:id',//仪才秀
            component: article
        },
        {
            path: '/college/standard',//标准
            component: category
        },
        {
            path: '/college/standard:id',//标准
            component: category
        },
        {
            path: '/college/standard/:id',//标准详情
            component: article
        },
        {
            path: '/college/article',
            component: article
        },
        {
            name: 'user_shop',
            path: '/shops/index/:id',
            component: shops
        },

        {
            path: '/shops/commodity/:id?/:value?',
            component: commodity
        },
        {
            path: '/shops/case',
            component: anli
        },
        {
            path: '/shops/case/:id',
            component: anli
        },
        {
            path: '/shops/video',
            component: yicaixiu
        },
        {
            path: '/shops/video/:id',
            component: yicaixiu
        },
        {
            path: '/shops/programme',
            component: fangan
        },
        {
            path: '/shops/programme/:id',
            component: fangan
        },
        {
            path: '/shops/light',
            component: diandeng
        },
        {
            path: '/shops/light/:id',
            component: diandeng
        },

        {
            path: '/shops/standard',
            component: biaozhun
        },
        {
            path: '/shops/standard/:id',
            component: biaozhun
        },
        {
            path: '/shops/companyData',
            component: gongsiziliao
        },
        {
            path: '/shops/companyData/:id',
            component: gongsiziliao
        },
        {
            path: '/shops/service',
            component: fuwu
        },
        {
            path: '/shops/service/:id',
            component: fuwu
        },
        {
            path: '/shops/bidding/:id',
            component: shop_bidding
        },
        {
            name: 'fuwuzhida',
            path: '/service/index',//服务主页
            component: service_index
        },
        {
            name: 'service_search',
            path: '/service/search',//服务列表
            component: service_search
        },
        {
            name: 'service_detail',
            path: '/service/details/:id',//服务详情
            component: service_details
        },
        {
            path: '/service/purchase/:id',//服务下单
            component: service_purchase
        },
        {
            name: 'ershoushangpin',
            path: '/second_goods/index',//二手商品
            component: ershousp
        },
        {
            name: 'yibingyijiang',
            path: '/general/index',//仪兵仪将
            component: general
        },
        {
            name: 'yibingyijiang_detail',
            path: '/general/index/:id',//仪兵仪将
            component: general
        },
        {
            name: 'jianyanjiance',
            path: '/testing/index',//检验检测
            component: testing
        },
        {
            path:'/chat_room/:id',//聊天室
            component:chat_room
        },
        {
            path:'/chat_list',//聊天列表
            component:chat_list
        },
        {
            path:'/chat_new/:id?',//新聊天室
            component:chat_new
        },
        {
            path:'/dianpu_new/:id',//商品展示新页面
            component:dianpu_new
        }
        ,{
            path:'/test',//聊天列表
            component:test
        },{
            path:'/leaflet/:id',
            component:leaflet
        },{
            path:'/application/:id',
            component:application

        },
        {
            path:'/chanpinku_info',
            component:chanpinku_info
        },
        {
            path:'/index_new/:id',
            component:index_new
        },
        {
            path:'/video_details/:id',//仪才秀详情
            component:video_details
        },
        {
            path:'/program_details/:id',//应用方案详情
            component:program_details
        },
        {
            path:'/standard_details/:id',//行业标准详情
            component:standard_details
        },

        {
            name:'wiki',
            path:'/wiki',
            component:wiki
        },
        {
            name:'wiki_search',
            path:'/wiki/search/:brand_name',
            component:wiki_search
        },
        {
            name:'wiki_search_filter',
            path:'/wiki/search/:brand_name/:key',
            component:wiki_search
        },
        {
            name:'wiki_detail',
            path:'/wiki/detail/:id',
            component:wiki_detail
        },
        {
            name:'bidding',
            path:'/bidding',
            component:bidding
        },
        {
            name:'bidding_single',
            path:'/bidding/:id',
            component:bidding_single
        },

        {
            name:'self_goods',
            path:'/self_goods',
            component:self_goods
        },

        {
            name:'self_goods_detail',
            path:'/self_goods/:id',
            component:self_goods_detail
        }
    ]
});

export default router;
